import React from 'react';
import { cn } from '@/lib/utils';
import { DMImage } from '../custom-image/custom-image';
import DMTooltip from '../tooltip';

type BadgeIconProps = {
  showPoint: boolean;
  index: number;
  currentPoint: number;
  active: boolean | undefined;
  icon: string | undefined;
  percentCompleted: number | undefined;
  progressColor: string | undefined;
};
const LevelUpBadgeIcon: React.FC<BadgeIconProps> = ({
  showPoint,
  index,
  currentPoint,
  active,
  icon,
  percentCompleted,
  progressColor,
}) => {
  const containerClasses = cn(
    'bg-brand-third border border-slate-600',
    active ? 'rounded-full !w-16 !h-16' : 'rounded-md !w-11 !h-11',
    { 'mr-2': index === 0 }
  );

  if (active) {
    return (
      <DMTooltip
        open={showPoint}
        triggerContent={
          <div className={`relative ${containerClasses}`}>
            <DMImage
              src={icon as string}
              alt='Badge'
              width={100}
              height={100}
              className='w-full h-full p-2 object-fit'
            />
            <span
              className={cn(
                '-z-50 animate-ping-badge absolute top-0 left-0 inline-flex h-full w-full rounded-full opacity-75',
                progressColor
              )}
            />
          </div>
        }
        tooltipContent={
          active &&
          percentCompleted === 0 && (
            <p className='text-black font-semibold text-xl flex flex-col items-center'>
              {currentPoint} <span className='text-xs'>XP</span>
            </p>
          )
        }
      />
    );
  }

  return (
    <div className={containerClasses}>
      <DMImage
        src={icon as string}
        alt='Badge'
        width={100}
        height={100}
        className='w-full h-full p-2 object-fit'
      />
    </div>
  );
};

export default LevelUpBadgeIcon;
